export { default as NikoPatientSalesOrderTemplate } from './NikoPatientSalesOrderTemplate';